import { handleActions } from 'redux-actions'
import { setAvailableColumns, resetState } from '../actions'

const defaultState = []

export default handleActions(
  {
    [setAvailableColumns](state, action) {
      return action.payload
    },
    [resetState](state, action) {
      return defaultState
    },
  },
  defaultState
)
